import { render, staticRenderFns } from "./ContratoPF.vue?vue&type=template&id=84fc2264"
import script from "./ContratoPF.vue?vue&type=script&lang=js"
export * from "./ContratoPF.vue?vue&type=script&lang=js"
import style0 from "./ContratoPF.vue?vue&type=style&index=0&id=84fc2264&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports